// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-wpr {
  position: fixed;
  z-index: 1000;
  height: 71.4vh;
  top: 28.6vh;
}

.search-overlay {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  position: fixed;
  top: 0;
  transition: 0.3s;
  opacity: 0;
  visibility: hidden;
  z-index: 1;
}
.search-overlay.show-overlay {
  opacity: 1;
  visibility: visible;
}

.right-menu-sec {
  order: 2;
  right: 0px;
  display: flex;
  align-items: center;
  transform: translateX(108px);
  transition: 0.3s;
  z-index: 3;
  position: absolute;
  -webkit-user-select: none;
          user-select: none;
}
.right-menu-sec.open {
  transform: translateX(0px);
}
.right-menu-sec.open .simple-keyboard.hg-theme-default {
  animation: slide-down 0.3s 0.5s forwards;
}
.right-menu-sec .menu-btn {
  width: 15px;
  height: 70px;
  cursor: pointer;
  border-radius: 10px 0 0 10px;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(0, 0, 0, 0.8);
  background-image: url(/assets/images/right-menu-btn.svg);
}

.right-menu li:not(:last-child) {
  border-bottom: 1px solid #5c5c5c;
}
.right-menu li:first-child {
  overflow: hidden;
  border-radius: 20px 0 0 0;
}
.right-menu li:last-child {
  overflow: hidden;
  border-radius: 0 0 0 20px;
}
.right-menu li a {
  width: 108px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}
.right-menu li a span {
  display: block;
  font-size: 18px;
  margin-top: 7px;
  font-weight: bold;
}

.search-sec-wpr {
  top: 0;
  right: 0;
  position: absolute;
  width: calc(100vw - 150px);
  transform: translateX(100%);
  transition: 0.3s;
  z-index: -1;
}
.search-sec-wpr.open {
  right: 125px;
  transform: translateX(0%);
}

.search-sec {
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 50px;
  padding: 10px 10px 10px 40px;
  background-color: rgba(0, 0, 0, 0.8);
}
.search-sec .search-icon {
  margin-right: 30px;
}
.search-sec .search-input {
  flex: 1 0 0;
}
.search-sec .search-input input {
  border: 0;
  color: #fff;
  font-size: 26px;
  font-family: Sharp Sans;
  font-weight: 700;
  background: transparent;
  box-shadow: none;
  height: 80px;
  width: 100%;
}
.search-sec .other-btns {
  gap: 10px;
  display: flex;
  margin-left: 20px;
}
.search-sec .other-btns a {
  width: 80px;
  height: 80px;
  display: flex;
  overflow: hidden;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: #474747;
  box-shadow: inset 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}
.search-sec .other-btns a .fill-color {
  fill: #979797;
}
.search-sec .other-btns a.active, .search-sec .other-btns a:hover {
  background-color: #fff;
  box-shadow: none;
}
.search-sec .other-btns a.active .fill-color, .search-sec .other-btns a:hover .fill-color {
  fill: #000;
}

@keyframes slide-down {
  0% {
    transform: translateY(-30px);
    max-height: 0px;
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    max-height: 700px;
    opacity: 1;
  }
}
.global-search-result .two-v-scroller {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  left: 0 !important;
  top: calc(100% + 10px) !important;
  width: max(30%, 390px);
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-header {
  background-color: rgba(0, 0, 0, 0.9);
  border-top-left-radius: 30px;
  border-width: 0px;
  padding-bottom: 5px;
  margin-bottom: -1px;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-header .search-list-label {
  color: #999;
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  margin-left: 20px;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content {
  background: transparent;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller {
  gap: 10px;
  display: grid;
  padding: 10px;
  padding-top: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 30px;
  flex-direction: column;
  max-height: 312px;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
  height: unset !important;
  contain: unset !important;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #5a5a5a;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller::-webkit-scrollbar-track {
  background: #3e3e3e;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller .p-scroller-content {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller .p-scroller-content .p-virtualscroller-item {
  width: 100%;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  border-radius: 30px;
  background-color: #414141;
  padding: 12px 20px;
  height: auto !important;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller .p-scroller-content .p-virtualscroller-item:last-child {
  margin-bottom: 15px;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller .p-scroller-content .p-virtualscroller-item a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  white-space: break-spaces;
}
.global-search-result ::ng-deep .p-virtualscroller .p-virtualscroller-content .p-scroller .p-scroller-content .p-virtualscroller-item a .directory-number {
  font-size: 20px;
  color: #999;
}

.right-menu-sec-d {
  position: fixed;
  right: 0;
  height: 605px; /*Important note: .right-menu-sec div's height*/
}

.drag-parent-block {
  display: flex;
  align-items: center;
  top: calc(50% + max(300px, 28.6vh) / 2);
  position: fixed;
  z-index: 10;
}

.right-menu--clicks img,
.right-menu--clicks span {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./projects/clientside/src/app/components/widgets/mappedin-search/mappedin-search.component.scss","webpack://./projects/clientside/src/_variable.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,aAAA;EACA,cAAA;EACA,WCNa;ADKf;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAAF;AACE;EACE,UAAA;EACA,mBAAA;AACJ;;AAEA;EACE,QAAA;EACA,UAAA;EACA,aAAA;EAEA,mBAAA;EAEA,4BAAA;EAEA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAFF;AAGE;EAEE,0BAAA;AAFJ;AAGI;EACE,wCAAA;AADN;AAIE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,oCAAA;EACA,wDAAA;AAFJ;;AAME;EACE,gCAAA;AAHJ;AAKE;EACE,gBAAA;EACA,yBAAA;AAHJ;AAKE;EACE,gBAAA;EACA,yBAAA;AAHJ;AAKE;EAGE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;AALJ;AAMI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AAJN;;AAQA;EACE,MAAA;EACA,QAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;AALF;AAME;EACE,YAAA;EACA,yBAAA;AAJJ;;AAOA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,oCAAA;AAJF;AAKE;EACE,kBAAA;AAHJ;AAKE;EACE,WAAA;AAHJ;AAII;EACE,SAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAFN;AAwCE;EACE,SAAA;EACA,aAAA;EACA,iBAAA;AAtCJ;AAuCI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iDAAA;AArCN;AAsCM;EACE,aAAA;AApCR;AAsCM;EAEE,sBAAA;EACA,gBAAA;AArCR;AAsCQ;EACE,UAAA;AApCV;;AAyGA;EACE;IACE,4BAAA;IACA,eAAA;IACA,UAAA;EAtGF;EAwGA;IACE,0BAAA;IACA,iBAAA;IACA,UAAA;EAtGF;AACF;AA0GE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,sBAAA;AAxGJ;AA6GI;EACE,oCAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AA3GN;AA4GM;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AA1GR;AA6GI;EACE,uBAAA;AA3GN;AA4GM;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,oCAAA;EACA,wBAAA;EACA,yBAAA;AA1GR;AA2GQ;EACE,UAAA;EACA,WAAA;AAzGV;AA2GQ;EACE,kBAAA;EACA,mBAAA;AAzGV;AA2GQ;EACE,mBAAA;AAzGV;AA2GQ;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzGV;AA0GU;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;AAxGZ;AAyGY;EACE,mBAAA;AAvGd;AAyGY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;AAvGd;AAwGc;EACE,eAAA;EACA,WAAA;AAtGhB;;AA2HA;EACE,eAAA;EAEA,QAAA;EACA,aAAA,EAAA,+CAAA;AAzHF;;AA4HA;EACE,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,WAAA;AAzHF;;AA4HE;;EAEE,oBAAA;AAzHJ","sourcesContent":["@import '../../../../variable';\n\n.search-wpr {\n  position: fixed;\n  z-index: 1000;\n  height: calc(100vh - $image_height);\n  top: $image_height;\n}\n.search-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  bottom: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.15);\n  position: fixed;\n  top: 0;\n  transition: 0.3s;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 1;\n  &.show-overlay {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n.right-menu-sec {\n  order: 2;\n  right: 0px;\n  display: flex;\n  // position: fixed;\n  align-items: center;\n  // transform: translateY(-50%) translateX(100px);\n  transform: translateX(108px);\n  // top: calc(50% + calc(max(300px, 23.43vh) / 2));\n  transition: 0.3s;\n  z-index: 3;\n  position: absolute;\n  user-select: none;\n  &.open {\n    // transform: translateY(-50%) translateX(0);\n    transform: translateX(0px);\n    .simple-keyboard.hg-theme-default {\n      animation: slide-down 0.3s 0.5s forwards;\n    }\n  }\n  .menu-btn {\n    width: 15px;\n    height: 70px;\n    cursor: pointer;\n    border-radius: 10px 0 0 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-color: rgba(0, 0, 0, 0.8);\n    background-image: url(/assets/images/right-menu-btn.svg);\n  }\n}\n.right-menu li {\n  &:not(:last-child) {\n    border-bottom: 1px solid #5c5c5c;\n  }\n  &:first-child {\n    overflow: hidden;\n    border-radius: 20px 0 0 0;\n  }\n  &:last-child {\n    overflow: hidden;\n    border-radius: 0 0 0 20px;\n  }\n  a {\n    // width: min(5.21vh, 100px);\n    // height: min(5.21vh, 100px);\n    width: 108px;\n    height: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #fff;\n    span {\n      display: block;\n      font-size: 18px;\n      margin-top: 7px;\n      font-weight: bold;\n    }\n  }\n}\n.search-sec-wpr {\n  top: 0;\n  right: 0;\n  position: absolute;\n  width: calc(100vw - 150px);\n  transform: translateX(100%);\n  transition: 0.3s;\n  z-index: -1;\n  &.open {\n    right: 125px;\n    transform: translateX(0%);\n  }\n}\n.search-sec {\n  display: flex;\n  position: relative;\n  align-items: center;\n  border-radius: 50px;\n  padding: 10px 10px 10px 40px;\n  background-color: rgba(0, 0, 0, 0.8);\n  .search-icon {\n    margin-right: 30px;\n  }\n  .search-input {\n    flex: 1 0 0;\n    input {\n      border: 0;\n      color: #fff;\n      font-size: 26px;\n      font-family: Sharp Sans;\n      font-weight: 700;\n      background: transparent;\n      box-shadow: none;\n      height: 80px;\n      width: 100%;\n    }\n    // ::ng-deep .p- {\n    //   &autocomplete-clearable {\n    //     position: unset;\n    //   }\n    //   &component {\n    //     width: 100%;\n    //   }\n    //   &inputtext {\n    //     border: 0;\n    //     color: #fff;\n    //     font-size: 26px;\n    //     font-family: Sharp Sans;\n    //     font-weight: 700;\n    //     background: transparent;\n    //     box-shadow: none;\n    //     height: 80px;\n    //     width: 100%;\n    //     &::-webkit-input-placeholder {\n    //       color: #aaa;\n    //     }\n    //     &::-moz-placeholder {\n    //       color: #aaa;\n    //     }\n    //     &:-ms-input-placeholder {\n    //       color: #aaa;\n    //     }\n    //     &:-moz-placeholder {\n    //       color: #aaa;\n    //     }\n    //   }\n    //   &autocomplete-clear-icon.p-icon {\n    //     width: 23px;\n    //     height: 23px;\n    //   }\n    // }\n  }\n  .other-btns {\n    gap: 10px;\n    display: flex;\n    margin-left: 20px;\n    a {\n      width: 80px;\n      height: 80px;\n      display: flex;\n      overflow: hidden;\n      border-radius: 50%;\n      align-items: center;\n      justify-content: center;\n      background-color: #474747;\n      box-shadow: inset 0 4px 4px 0 rgba(0, 0, 0, 0.25);\n      .fill-color {\n        fill: #979797;\n      }\n      &.active,\n      &:hover {\n        background-color: #fff;\n        box-shadow: none;\n        .fill-color {\n          fill: #000;\n        }\n      }\n    }\n  }\n\n  // ::ng-deep .p-overlay.p-component {\n  //   width: 100%;\n  //   position: absolute;\n  //   left: 0 !important;\n  //   top: calc(100% + 10px) !important;\n  //   .p-autocomplete-panel {\n  //     //   width: 42%;\n  //     max-width: 390px;\n  //     position: unset;\n  //     background: transparent;\n  //     border: 0;\n  //     box-shadow: none;\n  //     max-height: unset !important;\n  //   }\n  //   .p-autocomplete-items {\n  //     gap: 10px;\n  //     display: grid;\n  //     padding: 10px;\n  //     border-radius: 30px;\n  //     border-top-right-radius: 0px;\n  //     border-bottom-right-radius: 0px;\n  //     flex-direction: column;\n  //     max-height: 348px;\n  //     overflow: auto;\n  //     background-color: rgba(0, 0, 0, 0.9);\n  //     &::-webkit-scrollbar {\n  //       width: 8px;\n  //       height: 8px;\n  //     }\n  //     &::-webkit-scrollbar-thumb {\n  //       border-radius: 8px;\n  //       background: #5a5a5a;\n  //     }\n  //     &::-webkit-scrollbar-track {\n  //       background: #3e3e3e;\n  //     }\n  //     .p-autocomplete-item {\n  //       width: 100%;\n  //       color: #fff;\n  //       font-size: 24px;\n  //       font-weight: bold;\n  //       border-radius: 30px;\n  //       background-color: #414141;\n  //       padding: 12px 20px;\n  //       .directory-sug {\n  //         display: flex;\n  //         justify-content: space-between;\n  //         align-items: center;\n  //         flex-wrap: wrap;\n  //         gap: 10px;\n  //         & > * {\n  //           white-space: break-spaces;\n  //         }\n  //       }\n  //       .directory-number {\n  //         font-size: 20px;\n  //         color: #999;\n  //       }\n  //     }\n  //   }\n  // }\n}\n\n@keyframes slide-down {\n  0% {\n    transform: translateY(-30px);\n    max-height: 0px;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    max-height: 700px;\n    opacity: 1;\n  }\n}\n\n.global-search-result {\n  .two-v-scroller {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    position: absolute;\n    left: 0 !important;\n    top: calc(100% + 10px) !important;\n    width: max(30%, 390px);\n  }\n  ::ng-deep .p-virtualscroller {\n    // width: 100%;\n    // max-width: 390px;\n    .p-virtualscroller-header {\n      background-color: rgba(0, 0, 0, 0.9);\n      border-top-left-radius: 30px;\n      border-width: 0px;\n      padding-bottom: 5px;\n      margin-bottom: -1px;\n      .search-list-label {\n        color: #999;\n        font-size: 14px;\n        line-height: 18px;\n        font-weight: 700;\n        margin-left: 20px;\n      }\n    }\n    .p-virtualscroller-content {\n      background: transparent;\n      .p-scroller {\n        gap: 10px;\n        display: grid;\n        padding: 10px;\n        padding-top: 5px;\n        border-top-right-radius: 0px;\n        border-bottom-right-radius: 0px;\n        border-bottom-left-radius: 30px;\n        flex-direction: column;\n        max-height: 312px;\n        overflow: auto;\n        background-color: rgba(0, 0, 0, 0.9);\n        height: unset !important;\n        contain: unset !important;\n        &::-webkit-scrollbar {\n          width: 8px;\n          height: 8px;\n        }\n        &::-webkit-scrollbar-thumb {\n          border-radius: 8px;\n          background: #5a5a5a;\n        }\n        &::-webkit-scrollbar-track {\n          background: #3e3e3e;\n        }\n        .p-scroller-content {\n          position: relative;\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          .p-virtualscroller-item {\n            width: 100%;\n            color: #fff;\n            font-size: 24px;\n            font-weight: bold;\n            border-radius: 30px;\n            background-color: #414141;\n            padding: 12px 20px;\n            height: auto !important;\n            &:last-child {\n              margin-bottom: 15px;\n            }\n            a {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              flex-wrap: wrap;\n              gap: 10px;\n              white-space: break-spaces;\n              .directory-number {\n                font-size: 20px;\n                color: #999;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1080px) {\n  // .search-sec ::ng-deep .p-overlay.p-component .p-autocomplete-panel {\n  //   max-width: 390px;\n  // }\n  .simple-keyboard.hg-theme-default {\n    // max-width: 523px;\n  }\n}\n// ul.right-menu {\n//   padding: 7px 0px 48px;\n// }\n.right-menu-sec-d {\n  position: fixed;\n  // top: calc(43% + max(300px, 23.43vh) / 2);\n  right: 0;\n  height: 605px; /*Important note: .right-menu-sec div's height*/\n  // transform: translateY(50%);\n}\n.drag-parent-block {\n  display: flex;\n  align-items: center;\n  top: calc(50% + calc(max(300px, $image_height) / 2));\n  position: fixed;\n  z-index: 10;\n}\n.right-menu--clicks {\n  img,\n  span {\n    pointer-events: none;\n  }\n}\n","$image_height: 28.6vh;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
